import React, { useEffect, useState } from 'react'
import { withStyles, Typography } from '@material-ui/core'
import styles from './styles'
import { Icon } from '@iconify/react'
import { useDispatch, useSelector } from 'react-redux'
import { getCourseLandingPageAction } from 'src/reducers/course/action'
import {
  HeaderSettingsLanguage,
  HeaderSettingsTheme,
  HeaderSettingsType,
} from './components'

const HeaderSettings = props => {
  const { classes, onSave } = props
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const id = window.location.pathname.split('/')[2]
  const pageUrl = window.location.pathname.split('/')[1]
  const courseSettings = useSelector(state => state.course.landingPageSettings)
  const collectionSettings = useSelector(
    state => state.collection.landingPageSettings,
  )
  // Then conditionally use the results
  const landingPageData =
    pageUrl === 'mini-course' ? courseSettings : collectionSettings

  // Initialize theme settings properly
  const initialPosition =
    landingPageData?.sections?.[0]?.content?.alignment || 'center'
  const initialBackground = landingPageData?.sections?.[0]?.content?.image || ''

  const [themeSettings, setThemeSettings] = useState({
    background: initialBackground,
    selectedPosition: initialPosition,
  })

  // Add state for button text values
  const [selectedStartValue, setSelectedStartValue] = useState('Start Course')
  const [selectedResumeValue, setSelectedResumeValue] = useState(
    'Resume Course',
  )

  const course = useSelector(state => state.course.course)

  // Log the theme settings whenever they change
  useEffect(() => {}, [themeSettings])

  // Replace useTabs with simple activeTab state
  const [activeTab, setActiveTab] = useState('Theme')

  // Fix: Create the tabList properly to exclude Language tab for non-mini-course pages
  const tabList = [
    {
      label: 'Theme',
      path: 'Theme',
      icon: 'fluent:window-brush-20-regular',
    },
    {
      label: 'Type',
      path: 'Type',
      icon: 'mynaui:layout',
    },
  ]

  // Only add Language tab for mini-course pages
  if (pageUrl === 'mini-course') {
    tabList.push({
      label: 'Language',
      path: 'Language',
      icon: 'prime:language',
    })
  }

  // Create a function to update the onSave callback with latest values
  const updateSaveCallback = updatedData => {
    if (onSave && typeof onSave === 'function') {
      onSave({
        ...themeSettings,
        id: id,
        landingPageSettings: {
          ...landingPageData,
          localizations: {
            ...(landingPageData?.localizations || {}),
            startButton: selectedStartValue,
            resumeButton: selectedResumeValue,
            ...updatedData?.localizations,
          },
          ...updatedData,
        },
      })
    }
  }

  // Call updateSaveCallback whenever button values change
  useEffect(() => {
    updateSaveCallback({
      localizations: {
        startButton: selectedStartValue,
        resumeButton: selectedResumeValue,
      },
    })
  }, [selectedStartValue, selectedResumeValue])

  // Fixed handleThemeSettingsChange function
  const handleThemeSettingsChange = (settingName, value) => {
    // Create updated theme settings
    const updatedSettings = {
      ...themeSettings,
      [settingName]: value,
    }

    // Update the local state first
    setThemeSettings(updatedSettings)

    // Prepare data for the onSave callback
    const updatedData = {}

    // If the changed setting is selectedPosition, add it to the updated data as alignment
    if (settingName === 'selectedPosition') {
      updatedData.alignment = value
    }

    // If the changed setting is background, add it to the updated data as image
    if (settingName === 'background') {
      updatedData.image = value
    }

    // Call onSave with the updated settings
    if (onSave && typeof onSave === 'function') {
      onSave({
        ...updatedSettings,
        id: id,
        landingPageSettings: {
          ...landingPageData,
          localizations: {
            ...(landingPageData?.localizations || {}),
            startButton: selectedStartValue,
            resumeButton: selectedResumeValue,
          },
          ...updatedData,
        },
      })
    }
  }

  const handleButtonTextChange = (type, value) => {
    if (type === 'start') {
      setSelectedStartValue(value)
    } else if (type === 'resume') {
      setSelectedResumeValue(value)
    }
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'Theme':
        return (
          <HeaderSettingsTheme
            landingPageData={landingPageData}
            isLoading={isLoading}
            themeSettings={themeSettings}
            onThemeSettingsChange={handleThemeSettingsChange}
          />
        )
      case 'Type':
        return (
          <HeaderSettingsType
            landingPageData={landingPageData}
            isLoading={isLoading}
            themeSettings={themeSettings}
          />
        )
      case 'Language':
        return pageUrl === 'mini-course' ? (
          <HeaderSettingsLanguage
            landingPageData={landingPageData}
            isLoading={isLoading}
            themeSettings={themeSettings}
            selectedStartValue={selectedStartValue}
            selectedResumeValue={selectedResumeValue}
            onButtonTextChange={handleButtonTextChange}
          />
        ) : null
      default:
        return null
    }
  }

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.sidebar}>
          {tabList.map(item => (
            <div
              key={item.path}
              className={`${classes.leftSideListItem} ${
                activeTab === item.path ? classes.active : ''
              }`}
              onClick={() => setActiveTab(item.path)}
            >
              <Icon
                icon={item.icon}
                style={{
                  width: '18px',
                  height: '18px',
                }}
              />
              <Typography fontWeight={400}>{item.label}</Typography>
            </div>
          ))}
        </div>
        <div className={classes.mainContent}>{renderContent()}</div>
      </div>
    </div>
  )
}

export default withStyles(styles)(HeaderSettings)
